(() => {
    "use strict";
    let e = {
            onLoad() {
                let { container: e } = this;
                try {
                    AT.detectVisible({
                        element: e,
                        rootMargin: "0px",
                        callback: () => {
                            e.querySelector("slider-component").init();
                        },
                    });
                } catch (t) {
                    console.log(e), console.error(t);
                }
            },
        },
        t = (e, t, n) => {
            let a = {};
            if (!e) return;
            console.log(t);
            let i = e.dataset.statusSoldOut,
                r = e.getElementsByClassName("js-option-item");
            function o(t) {
                let n,
                    r,
                    o = s();
                switch (t) {
                    case 1:
                        (n = "root"), (r = e.querySelector(".js-swatch-item[data-position='1']"));
                        break;
                    case 2:
                        (n = o.option1), (r = e.querySelector(".js-swatch-item[data-position='2']"));
                        break;
                    case 3:
                        (n = o.option1 + " / " + o.option2), (r = e.querySelector(".js-swatch-item[data-position='3']"));
                }
                switch (r.dataset.style) {
                    case "select": {
                        let e = r.getElementsByClassName("js-option-item")[0],
                            t = e.value;
                        switch (i) {
                            case "hide":
                                (e.innerHTML = a[n].map((e) => `<option value="${e}">${e}</option>`).join("")), a[n].includes(t) && (e.value = t);
                                break;
                            case "disable":
                                [...e.options].forEach((e) => {
                                    a[n].includes(e.value) ? (e.disabled = !1) : ((e.disabled = !0), (e.selected = !1));
                                }),
                                    [...e.options].find((e) => 0 == e.disabled && (e.selected = !0));
                        }
                        break;
                    }
                    case "color":
                    case "image":
                    case "button":
                        let e = r.getElementsByClassName("js-option-item"),
                            t = [...e].find((e) => e.checked).value;
                        switch (i) {
                            case "hide":
                                e.forEach((i) => {
                                    a[n].includes(i.value) ? i.closest(".swatch-group_wrapper").removeClass("d-none") : (i.closest(".swatch-group_wrapper").addClass("d-none"), t === i.value && ((i.checked = !1), (e[0].checked = !0)));
                                });
                                break;
                            case "disable":
                                e.forEach((i) => {
                                    a[n].includes(i.value) ? (i.disabled = !1) : ((i.disabled = !0), t === i.value && ((i.checked = !1), (e[0].checked = !0)));
                                });
                        }
                }
                e.dispatchEvent(new CustomEvent("swatch-change", { detail: { position: t, optionValue: o[`option${t}`] } }));
            }
            function s() {
                return [...e.getElementsByClassName("js-swatch-item")].reduce((e, t) => {
                    switch (t.dataset.style) {
                        case "select":
                            let n = t.querySelector("select.single-option-selector");
                            e[n.name] = n.value;
                            break;
                        case "color":
                        case "image":
                        case "button":
                            let a = t.querySelectorAll("input[data-single-option-selector]");
                            e[a[0].name] = [...a].find((e) => e.checked).value;
                    }
                    return e;
                }, {});
            }
            function l(e) {
                return t.variants.find((t) => Object.keys(e).every((n) => t[n] === e[n]));
            }
            t.variants.length < 2 ||
                (r.addEvents("change", function () {
                    e.dispatchEvent(new CustomEvent("swatch-change", { detail: { position: +this.dataset.optionPosition, optionValue: this.value } }));
                }),
                e.addEvent("swatch-change", function ({ detail: { position: a, optionValue: i } }) {
                    switch (((e.querySelector(`[data-selected-option='option${a}']`).innerHTML = i), a)) {
                        case 1:
                            t.options.length > 1 ? o(2) : n(l(s()));
                            break;
                        case 2:
                            3 === t.options.length ? o(3) : n(l(s()));
                            break;
                        case 3:
                            n(l(s()));
                    }
                }),
                t.variants.forEach((e) => {
                    if (e.available) {
                        if (((a.root = a.root || []), a.root.push(e.option1), (a.root = a.root.reduce((e, t) => (e.includes(t) || e.push(t), e), [])), t.options.length > 1)) {
                            var n = e.option1;
                            (a[n] = a[n] || []), a[n].push(e.option2), (a[n] = a[n].reduce((e, t) => (e.includes(t) || e.push(t), e), []));
                        }
                        if (3 === t.options.length) {
                            n = e.option1 + " / " + e.option2;
                            (a[n] = a[n] || []), a[n].push(e.option3), (a[n] = a[n].reduce((e, t) => (e.includes(t) || e.push(t), e), []));
                        }
                    }
                }),
                o(1));
        };
    HTMLElement;
    HTMLElement;
    HTMLElement;
    HTMLElement;
    HTMLElement;
    HTMLElement;
    let n = {
        onLoad: function () {
            this.firstLoad = true;
            let e = this.container;
            if (
                ((this.product = theme.product),
                (this.elms = {
                    priceCompareElement: e.querySelector(".js-price-compare"),
                    priceElement: e.querySelector(".js-price"),
                    skuElement: e.querySelector(".js-sku"),
                    inventoryElement: e.querySelector(".js-inventory"),
                    mediaMain: document.getElementById("product-media-main"),
                    mediaThumnails: document.getElementById("product-media-thumnails"),
                    selectMaster: e.querySelector("#select-master"),
                    addToCartButton: e.querySelector(".js-atc-btn"),
                    formElement: e.querySelector("form[action*='/cart/add']"),
                    labelSaveContainer: e.querySelector(".js-product-label-save"),
                    swatchContainer: e.querySelector("swatch-component"),
                    findStoreButton: e.querySelector(".js-find-store-btn"),
                    quantityInputContainer: e.querySelector(".js-product-quantity"),
                    subscribeForm: e.querySelector("#contact-notify-when-available"),
                    dynamicCheckoutContainer: e.querySelector(".js-product-dymanic-checkout"),
                }),
                (this.settings = JSON.parse(this.container.querySelector("[data-settings]").innerHTML)),
                document.querySelector(".shipping-time") && (this.initOrderDeadLine(), this.initOrderShipping()),
                document.querySelector("#bundledAddToCart") && (this.initProductItemEvents(), this.initMultiVariantEvents()),
                this.initSliderMedia(),
                this.initInventory(),
                this.initFormAddToCart(),
                t(this.elms.swatchContainer, this.product, this.handleVariantChange.bind(this)),
                this.initScrollToReviews(),
                AT.getParameterByName("contact_posted"))
            ) {
                this.switchVariantById(AT.cookie.get("subscribe-variant-id")), AT.cookie.delete("subscribe-variant-id");
                let e = window.location.search
                    .replace("?", "")
                    .split("&")
                    .filter((e) => !e.includes("contact_posted"))
                    .filter(Boolean)
                    .join("&");
                window.history.replaceState({}, "", `${window.location.pathname}?${e}`);
            }
        },
        initProductItemEvents() {
            document.querySelectorAll(".js-input-quantity");
            this.initAddToCartFormEvent();
        },
        initAddToCartFormEvent(e) {
            let t = document.querySelector(".js-bundledAddToCart"),
                n = t.querySelector(".js-btn-add-to-cart");
            t.addEvent("submit", (e) => {
                e.preventDefault();
                let a = [...t.querySelectorAll("input[name='quantity']")].reduce((e, t) => (+t.value > 0 && e.push({ id: +t.dataset.variantId, quantity: +t.value }), e), []);
                a.length &&
                    (n.hasClass("has-pending") ||
                        n.insertAdjacentHTML(
                            "beforeend",
                            '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>'
                        ),
                    n.addClass("pending", "has-pending"),
                    Cart.addMutiple(a)
                        .then((e) => {})
                        .finally(() => {
                            n.removeClass("pending"), (window.location.href = "/cart");
                        }));
            });
        },
        initMultiVariantEvents() {
            let e = document.querySelectorAll(".select-master-bundle"),
                t = document.querySelectorAll(".bundled-checkbox"),
                n = document.querySelector(".js-bundled-total-price"),
                a = Number(document.querySelector(".bundled-total-price").getAttribute("data-bundled-total-price"));
            t.forEach(function (e) {
                e.addEventListener("change", function () {
                    let e = this.closest(".bundled-item"),
                        t = this.getAttribute("data-id"),
                        i = Number(this.getAttribute("data-price"));
                    this.checked
                        ? ((a += i),
                          (e.querySelector(".js-input-quantity").value = "1"),
                          document.querySelector("#" + t).removeClass("d-none"),
                          e.querySelector(".select-group-bundle").hasClass("select-multi-variants") && e.querySelector(".select-group-bundle").removeClass("d-none"))
                        : ((a -= i),
                          (e.querySelector(".js-input-quantity").value = "0"),
                          document.querySelector("#" + t).addClass("d-none"),
                          e.querySelector(".select-group-bundle").hasClass("select-multi-variants") && e.querySelector(".select-group-bundle").addClass("d-none")),
                        (n.innerHTML = a.toCurrency()),
                        document.querySelector(".bundled-total-price").setAttribute("data-bundled-total-price", a),
                        (a = Number(document.querySelector(".bundled-total-price").getAttribute("data-bundled-total-price")));
                });
            }),
                e.forEach(function (e) {
                    e.addEventListener("change", function () {
                        let e = this.getAttribute("id"),
                            t = this.closest(".bundled-item"),
                            i = Number(this.options[this.selectedIndex].getAttribute("data-option-price"));
                        Number(t.querySelector(".bundled-checkbox").setAttribute("data-price", i));
                        t.querySelector(".js-input-quantity").setAttribute("id", this.value), t.querySelector(".js-input-quantity").setAttribute("data-variant-id", this.value), (document.querySelector("." + e).innerHTML = i.toCurrency());
                        let r = 0;
                        document.querySelectorAll(".bundled-checkbox").forEach(function (e) {
                            if (e.checked) {
                                let t = Number(e.getAttribute("data-price"));
                                r += t;
                            }
                        }),
                            (n.innerHTML = r.toCurrency()),
                            document.querySelector(".bundled-total-price").setAttribute("data-bundled-total-price", r),
                            (a = Number(document.querySelector(".bundled-total-price").getAttribute("data-bundled-total-price")));
                    });
                });
        },
        initOrderDeadLine() {
            let e = parseInt(document.querySelector(".shipping-time").getAttribute("data-deadline")),
                t = document.querySelector(".deadline"),
                n = new Date(),
                a = new Date(n.getFullYear(), n.getMonth(), n.getDate());
            a.setHours(e), (t.innerHTML = n >= a ? "Order until <strong>" + e + ":00 tomorrow</strong>" : "Order today until <strong>" + e + ":00</strong>");
        },
        initOrderShipping() {
            let e = new Date(),
                t = e,
                n = parseInt(document.querySelector(".shipping-time").getAttribute("data-deliverytime"));
            for (let a = 1; a <= n; a++) t = new Date(e.getTime() + 24 * a * 60 * 60 * 1e3);
            let a = new Array(7);
            (a[0] = "Sunday"), (a[1] = "Monday"), (a[2] = "Tuesday"), (a[3] = "Wednesday"), (a[4] = "Thurday"), (a[5] = "Friday"), (a[6] = "Saturday");
            let i = a[t.getDay()],
                r = new Array();
            (r[0] = "January"),
                (r[1] = "February"),
                (r[2] = "March "),
                (r[3] = "April"),
                (r[4] = "May"),
                (r[5] = "June"),
                (r[6] = "July"),
                (r[7] = "August"),
                (r[8] = "September"),
                (r[9] = "October"),
                (r[10] = "November"),
                (r[11] = "December");
            let o = r[t.getMonth()];
            document.querySelector(".dt-time").innerHTML = i + ",&nbsp;" + t.getDate() + "&nbsp;" + o;
        },
        initSliderMedia: function () {
            let { mediaMain: e, mediaThumnails: t } = this.elms;
            (this.mainSlider = e.init({ gutter: 12 })), t.init();
        },
        handleVariantChange: function (e) {
            let { skuElement: t, selectMaster: n, mediaMain: a } = this.elms;
          
            if (!e) return this.updateVariantStatus(), void a.addClass("product-sold-out");
            (this.currentVariant = e),
                this.updateLabelSave(e),
                this.updateVariantStatus(e),
                this.updatePrice(e),
                this.updateURLHash(e),
                e.available ? a.removeClass("product-sold-out") : a.addClass("product-sold-out"),
                e.sku ? (t.innerHTML = e.sku) : (t.innerHTML = theme.strings.product.skuNA),
                (n.value = e.id); 

              this.firstLoad == true ? this.firstLoad = false : (e.featured_media && this.mainSlider.goTo(e.featured_media.position - 1));

        },
        initInventory() {
            let { inventoryElement: e } = this.elms;
            this.inventory = {
                setStatus: (t, n) => {
                    if (this.settings.showInventory)
                        switch ((e.setAttribute("data-status", t), t)) {
                            case "coming-stock":
                                e.querySelector(".inventory_coming-stock").innerHTML = theme.strings.dateComingStock.replace("{{date}}", n.next_incoming_date);
                                break;
                            case "low-stock":
                                e.querySelector(".inventory_low-stock").innerHTML = (n.inventory_quantity > 1 ? theme.strings.product.itemsLowStock : theme.strings.product.itemLowStock).replace("{{quantity}}", n.inventory_quantity);
                                break;
                            case "items-stock":
                                e.querySelector(".inventory_items-stock").innerHTML = (n.inventory_quantity > 1 ? theme.strings.product.itemsStock : theme.strings.product.itemStock).replace("{{quantity}}", n.inventory_quantity);
                        }
                },
            };
        },
        updateVariantStatus(e) {
            let { addToCartButton: t } = this.elms;
            e
                ? (this.settings.enableSubscribe && (this.updateDynamicCheckout(e.available), this.updateSubscribeForm(e)), this.updateAddToCartButton(e), this.updateInventory(e))
                : ((t.disabled = !0),
                  (t.querySelector("span").innerHTML = theme.strings.product.unavailable),
                  document.querySelector(".product-wishlist-compare").addClass("d-none"),
                  document.querySelector(".people-in-cart").addClass("d-none"),
                  document.querySelector(".shipping-time").addClass("d-none"),
                  this.inventory.setStatus("out-stock"));
        },
        updateDynamicCheckout(e) {
            let { dynamicCheckoutContainer: t } = this.elms;
            t && (e ? t.removeClass("d-none") : t.addClass("d-none"));
        },
        updateSubscribeForm(e) {
            let { subscribeForm: t } = this.elms,
                n = t.querySelector("input[name='contact[body]']"),
                a = t.querySelector(".js-product-subscribe");
            !AT.getParameterByName("contact_posted") && a.removeClass("posted-successfully"),
                (n.value = n.dataset.value.replace("{{product_name}}", e.name)),
                e.available ? a.addClass("d-none") : a.removeClass("d-none"),
                t.addEvent("submit", () => {
                    AT.cookie.set("subscribe-variant-id", this.currentVariant.id);
                });
        },
        updateAddToCartButton(e) {
            let { addToCartButton: t, quantityInputContainer: n } = this.elms;
            e.available
                ? ((t.disabled = !1),
                  (t.querySelector("span").innerHTML = 0 == e.inventory_quantity && e.incoming ? theme.strings.product.preorder : theme.strings.product.addToCart),
                  this.settings.enableSubscribe && n.removeClass("d-none"),
                  document.querySelector(".product-wishlist-compare")?.removeClass("d-none"),
                  document.querySelector(".people-in-cart")?.removeClass("d-none"),
                  document.querySelector(".shipping-time")?.removeClass("d-none"))
                : ((t.disabled = !0),
                  (t.querySelector("span").innerHTML = theme.strings.product.soldOut),
                  this.settings.enableSubscribe && n.addClass("d-none"),
                  document.querySelector(".product-wishlist-compare")?.addClass("d-none"),
                  document.querySelector(".people-in-cart")?.addClass("d-none"),
                  document.querySelector(".shipping-time")?.addClass("d-none"));
        },
        updateInventory(e) {
            e.available
                ? e.inventory_management
                    ? 0 == e.inventory_quantity && e.incoming
                        ? this.inventory.setStatus("coming-stock", e)
                        : e.inventory_quantity <= this.settings.inventoryThreshold
                        ? this.inventory.setStatus("low-stock", e)
                        : this.inventory.setStatus("items-stock", e)
                    : this.inventory.setStatus("in-stock")
                : this.inventory.setStatus("out-stock");
        },
        initFormAddToCart() {
            let { formElement: e, addToCartButton: t } = this.elms;
            e.addEvent("submit", (n) => {
                n.preventDefault(),
                    t.hasClass("has-pending") ||
                        t.insertAdjacentHTML(
                            "beforeend",
                            '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>'
                        ),
                    t.addClass("pending", "has-pending"),
                    Cart.add(e)
                        .catch((e) => {
                            AT.loadPopupMessage().then(() => {
                                Popups.closeAll(), PopupMessage.open(e.description);
                            });
                        })
                        .finally(() => {
                            t.removeClass("pending");
                        });
            });
        },
        initScrollToReviews() {
            let e = document.querySelector("#product-reviews-widget");
            document.querySelector("#product-review-badge").addEvent("click", () => AT.scrollTo(e, 1e3, e.click()));
        },
        updateLabelSave(e) {
            let { labelSaveContainer: t } = this.elms,
                n = t.querySelector(".js-percent"),
                a = t.querySelector(".js-money-saved"),
                { compare_at_price: i, price: r } = e;
            i > r ? ((a.innerHTML = (i - r).toCurrency()), (n.innerHTML = Math.round(((i - r) / i) * 100)), t.removeClass("d-none")) : t.addClass("d-none");
        },
        updatePrice(e) {
            let { priceCompareElement: t, priceElement: n } = this.elms;
          console.log("ffffff");
          console.log(e);
            e.compare_at_price ? ((t.innerHTML = e.compare_at_price.toCurrency()), t.removeClass("d-none")) : t.addClass("d-none"), (n.innerHTML = e.price.toCurrency());
        },
        updateURLHash(e) {
            let t = window.location.search.replace("?", "").split("&").filter(Boolean);
            window.history.replaceState(
                {},
                "",
                AT.getParameterByName("variant") ? `${window.location.pathname}?${t.map((t) => (t.includes("variant") ? "variant=" + e.id : t)).join("&")}` : (t.unshift("variant=" + e.id), `${window.location.pathname}?${t.join("&")}`)
            );
        },
        switchVariantById(e) {
            let { swatchContainer: t } = this.elms,
                n = theme.product.variants.find((t) => t.id == e);
            n &&
                n.options.forEach((e, n) => {
                    [...t.querySelectorAll(`[name='option${n + 1}']`)].find((t) => {
                        switch (t.tagName) {
                            case "INPUT":
                                t.value == e && ((t.checked = !0), t.dispatchEvent(new Event("change")));
                                break;
                            case "SELECT":
                                (t.value = e), t.dispatchEvent(new Event("change"));
                        }
                    });
                });
        },
    };
    theme.sectionRegister.forEach((t) => {
        switch (t) {
            case "product-template":
                register(t, n);
                break;
            case "related-products":
                register(t, e);
        }
    }),
        load("*"),
        console.log("product-page.js loaded");
})();
